import { z } from 'zod';
import { usePromptStore } from '@/stores/PromptStore.ts';

const StoreSyncPromptValueSchema = z.object({
    profileConfigsString: z.string(),
    stepConfigsString: z.string(),
    promptConfigsString: z.string(),
    variableConfigsString: z.string(),
});

export const storeSyncPromptHandler = (rawValue: object) => {
    const value = StoreSyncPromptValueSchema.parse(rawValue);

    const promptStore = usePromptStore();
    promptStore.$patch({
        profileConfigsString: value.profileConfigsString,
        stepConfigsString: value.stepConfigsString,
        promptConfigsString: value.promptConfigsString,
        variableConfigsString: value.variableConfigsString,
    });
};
